import { Pipe, PipeTransform } from '@angular/core';
import { getNestedValue } from '@core/utils';

@Pipe({
    name: 'joinProperty',
    standalone: false
})
export class JoinPropertyPipe implements PipeTransform {
  transform(value: any[], params?: any): string {

    if (!Array.isArray(value) || value.length === 0) {
      return '';
    }

    const values: string[] = value
      .map(item => params?.propertyName ? getNestedValue(item, params?.propertyName) : item);
      
    return values.join(params?.separator || ', ');
  }
}
